import { useState } from 'react';
import { useNavigate, Navigate, Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { useTheme, ThemeToggle } from '../theme';
import { makeAuthStyles, errText } from './authStyles';

export default function RegisterPage() {
  const { user, register } = useAuth();
  const { colors } = useTheme();
  const S = makeAuthStyles(colors);
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError('');
    try {
      // PureTrack / Pushover keys are configured later on the Settings page.
      await register({ username: form.username, password: form.password });
      navigate('/', { replace: true });
    } catch (err) {
      setError(errText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={S.page}>
      <form style={S.card} onSubmit={submit}>
        <div style={S.topBar}><ThemeToggle /></div>
        <h1 style={S.title}>Create account</h1>
        <div style={S.field}>
          <label style={S.label}>Username</label>
          <input style={S.input} value={form.username} onChange={set('username')} autoCapitalize="none" autoCorrect="off" required />
        </div>
        <div style={S.field}>
          <label style={S.label}>Password</label>
          <input style={S.input} type="password" value={form.password} onChange={set('password')} minLength={4} required />
        </div>
        <div style={S.error}>{error}</div>
        <button style={S.button} type="submit" disabled={busy}>{busy ? 'Creating…' : 'Register'}</button>
        <Link to="/login" style={S.link}>I already have an account</Link>
      </form>
    </div>
  );
}
